import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { Courier } from '../../../models/Courier'
import { Colors } from '../../../styles/colors'
import {
  Column,
  SpaceBox,
  SpacedRow,
} from '../../../styles/commonStyledComponents'
import { Button, ButtonType } from '../../Common/Button'

interface CourierInfoProps {
  courier: Courier
  className?: string
}

const CourierInfo = ({ className, courier }: CourierInfoProps): JSX.Element => {
  const { email, name, phone } = courier
  const { t } = useTranslation()
  const history = useHistory()

  const openSchedule = () => {
    history.push('/schedules')
  }

  return (
    <Container className={className}>
      <Section>
        <StyledColumn>
          <SectionHeader>{t('courier')}</SectionHeader>
          <Name>{name}</Name>
        </StyledColumn>
        <Button
          label={t('view_schedule')}
          mode={ButtonType.PRIMARY}
          onClick={openSchedule}
        />
      </Section>
      <Divider />
      <Section>
        <Column>
          <SectionHeader>{t('contact')}</SectionHeader>
          <Info>
            <Label>{t('email_contact_label')}</Label>{' '}
            <Link href={`mailto:${email}`}>{email}</Link>
          </Info>
          <SpaceBox height={4} />
          <Info>
            <Label>{t('phone_contact_label')}</Label>{' '}
            <Link href={`tel:${phone}`}>{phone}</Link>
          </Info>
        </Column>
      </Section>
    </Container>
  )
}

const Container = styled.div`
  width: 410px;
  background: ${Colors.white};
  border: 1px solid ${Colors.textColor_50};
  box-sizing: border-box;
  box-shadow: 0px 8px 8px ${Colors.textColor_50};
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Section = styled(SpacedRow)`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
`

const SectionHeader = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${Colors.textColor_400};
  margin-bottom: 5px;
`

const Divider = styled.div`
  align-self: stretch;
  height: 1px;
  background-color: ${Colors.textColor_50};
`

const StyledColumn = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Info = styled.span`
  display: flex;
`

const Label = styled.span`
  font-size: 16px;
  line-height: 19px;
  color: ${Colors.textColor_300};
  margin-right: 8px;
`

const Link = styled.a`
  font-size: 16px;
  line-height: 19px;
  color: ${Colors.primaryColor_500};
`

const Name = styled.div`
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  line-height: 21px;
  color: ${Colors.textColor_500};
`

export default CourierInfo
